<header class="app-header">
    @if(showBackButton()) {
        <button mat-icon-button (click)="goBack()" aria-label="Volver a la lista de barcos">
          <mat-icon>arrow_back</mat-icon>
        </button>
    }

  <!-- Título principal -->
  <h1>{{ title() }}</h1>

  <!-- Subtítulo opcional -->
   @if (subtitle()) {
       <ng-container>
         <h2>{{ subtitle() }}</h2>
       </ng-container>
   }
</header>
